import React from "react";
import PopupTitleContainer from "./PopupTitleContainer";
import { messageType } from "@components/molecules/InputPopUp/types";
import LineViewContainer from "./LineView";
import CommentBodySection from "./CommentBodySection";
import styled from "styled-components/native";
import { VDBIcons } from "@utils/VDBIcons";
import { SpaceType } from "@components/atoms/Spacer/types";
import { css } from "styled-components/native";
import { getBoxShadow } from "@utils/product/productValidators";

const ReasonContainer = (props: any) => {
  const { type, title, children, applyShadow } = props;
  return (
    <CardContainer applyShadow={applyShadow}>
      <PopupTitleContainer
        type={type}
        PopUpIcon={
          [messageType.Error, messageType.Warning].includes(type)
            ? VDBIcons.WARNING
            : "success"
        }
        title={title}
        borderRadius={SpaceType.Basic}
      />
      <LineViewContainer background="error-01" />
      <CommentBodySection background="error-02" borderRadius={8}>
        {children}
      </CommentBodySection>
    </CardContainer>
  );
};
const CardContainer = styled.View<{
  applyShadow: boolean;
}>`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme["core-03"]};
  ${({ applyShadow }) =>
    applyShadow &&
    css`
      box-shadow: ${({ theme }) => getBoxShadow(theme.Shadows.Gentle)};
    `}
`;
export default ReasonContainer;
